import React from 'react'
import Tr from 'translations/Translations';
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";
import MailIcon from "@material-ui/icons/Mail";

function WorkableIconMailButton(
    {
        tooltip = Tr('send'),
        ...props
    }) {
    return <WorkableIconButton
        tooltip={tooltip}
        Icon={MailIcon}
        {...props}
    />
}

WorkableIconMailButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconMailButton;